<template>
  <div>
    <el-dialog
        :title="$t('text.reviewApproval')"
        :visible="isShowAdoptDialog"
        width="30%"
        @open="init"
        @close="handleDialog"
        :close-on-click-modal="false"
    >
      <div>
        <div style="font-size: 16px; display: flex">
          <i
              class="el-icon-info"
              style="color: #e6a23c; font-size: 22px; margin-right: 6px"
          ></i
          >{{ $t('message.confirmReviewApproval') }}
        </div>
        <p>
          <el-form ref="form" :model="form" :rules="rules" label-width="170px">
            <el-form-item :label="$t('text.remark')" prop="approveRemark">
              <el-input
                  type="textarea"
                  :placeholder="$t('message.inputReason')"
                  v-model="form.approveRemark"
              ></el-input>
            </el-form-item>
          </el-form>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    rowData: '',
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    isShowAdoptDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        orderId: '',
        status: '01',
        approveRemark: '',
      },
      rules: {
        approveRemark: [
          {required: true, message: this.$t('message.inputApprovalReason'), trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    init() {
      this.form.orderId = this.id
    },
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        orderId: '',
        status: '01',
        approveRemark: '',
      }
      this.$emit('update:isShowAdoptDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            ...this.form,
          }
          this.$axios
              .post('/creditApplicationRecord/approveCreditApplicationRecord', params)
              .then(res => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                    type: 'success',
                  })
                  this.$emit('update:isShowAdoptDialog', false)
                  this.$bus.$emit('refresh') //通知刷新
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                  })
                }
              })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>